import {
    Checkbox,
    Collapse,
    TableCell,
    TableRow,
  } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CompanyComplainsList from "../../forms/newCompany/companyComplainsList";


function CompaniesTableRow({ open, company, onRowClick, checked, onCheck, before}) {
    const { t: t_button } = useTranslation('Buttons');
    const { t: t_common } = useTranslation('Common');
    const { t: t_link} = useTranslation('Pages');

    const navigate = useNavigate();
    

    const onCellClick = async () => {
        onRowClick(company.id);
        // dispatch(resetFilter());
    }
    
    const renderUndeliveredComplains = () => {
        if(company.undeliveredComplains > 0) {
            return (
                `${t_common('yes')} (${company.undeliveredComplains})`
            )
        }
        else if(company.undeliveredComplains < 1 || company.undeliveredComplains) {
            return (`${t_common('no')} (0)`)
        }
    } 

    return (
        <>
            <TableRow
                className={`row ${open ? " active" : ""}`}
            >
                <TableCell padding="checkbox">
                    <Checkbox color="primary" checked={checked} onClick={onCheck} />
                </TableCell>
                <TableCell
                    padding="none"
                    className="fk-table-cell --first"
                    onClick={onCellClick}
                >
                    <span className="value">{company.id}</span>
                </TableCell>
                <TableCell
                    padding="none"
                    className="fk-table-cell"
                    onClick={onCellClick}
                >
                    <span className="value">
                        {company.name}
                    </span>
                </TableCell>
                <TableCell
                    padding="none"
                    className="fk-table-cell"
                    onClick={onCellClick}
                >
                    <span className="value" style={!company.isConfirmed ? {color: "#adadad"} : {}}>{company.email}</span>
                </TableCell>
                <TableCell
                    padding="none"
                    className="fk-table-cell"
                    onClick={onCellClick}
                >
                    <span className="value">{company.openReportsAmount}</span>
                </TableCell>
                <TableCell
                    padding="none"
                    className="fk-table-cell"
                    onClick={onCellClick}
                >
                    <span className="value">{company.closedReportsAmount}</span>
                </TableCell>
                <TableCell
                    padding="none"
                    className="fk-table-cell"
                    onClick={onCellClick}
                >
                    <span className="value">{company.allReportsLast30DaysAmount}</span>
                </TableCell>
                <TableCell
                    padding="none"
                    className="fk-table-cell"
                    onClick={onCellClick}
                >
                    <span className="value">{company.allReportsLast365DaysAmount}</span>
                </TableCell>
                <TableCell
                    padding="none"
                    className="fk-table-cell"
                    onClick={onCellClick}
                >
                    <span className={`value${company.undeliveredComplains > 0 ? ' error' : ''}`}>
                        {renderUndeliveredComplains()}
                    </span>
                </TableCell>
                <TableCell padding="none" className="fk-table-cell crud --last">
                    <span className="value">
                        <button
                            className="show-details-button"
                            onClick={() => {
                                const url = `${t_link('companyLink')}${company.id}${before ? `?before=${encodeURIComponent(before)}` : ''}`;
                                navigate(url);
                            }}
                        >
                            {t_button('show')}
                        </button>
                    </span>
                </TableCell>
            </TableRow>
            {open &&
                <TableRow className="row collapsed-data">
                    <TableCell padding="checkbox" />
                    <TableCell
                        className="fk-table-cell --first"
                        colSpan={8}
                    >
                        <Collapse in={open} timeout="auto" className="collapse">
                            <CompanyComplainsList companyId={company.id} />
                        </Collapse>
                    </TableCell>
                </TableRow>
            }

      </>
    );
}



export default CompaniesTableRow;
